import { PimProductV1StockStatusEnum } from '@redteclab/api/clients/bully'

export const productAccessorIsProductFreebie = (
  stockStatus?: PimProductV1StockStatusEnum,
): boolean => stockStatus === PimProductV1StockStatusEnum.Free
